import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'
import * as actions from './actions'
import { api } from './api'

function fetchRules(action$) {
  return action$
    .ofType(actions.fetchRules.toString())
    .throttleTime(5000)
    .exhaustMap(() => {
      return api
        .rxfetchRules()
        .mapResponse(actions.fetchRulesSuccess)
        .startWith(actions.fetchRulesPending())
        .catch(error => Observable.of(actions.fetchRulesFailed({ error })))
    })
}

const fetchRoundRobinByKey = action$ => (
  action$
    .ofType(actions.fetchRoundRobinByKey.toString())
    .pluck('payload')
    .mergeMap(({ roundRobinKey }) => (
      api
        .fetchRoundRobin(roundRobinKey)
        .map(({ response }) => actions.fetchRoundRobinByKeySuccess({ data: response, roundRobinKey }))
        .startWith(actions.fetchRoundRobinByKeyPending({ roundRobinKey }))
        .catch(err => Observable.of(actions.fetchRoundRobinByKeyFailed({ roundRobinKey, err })))
    ))
)

export const epic = combineEpics(fetchRules, fetchRoundRobinByKey)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/rules/epic.js